export { default } from './Backdrop';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Backdrop/index.js
// module id = 183
// module chunks = 9